import { Instance, types } from 'mobx-state-tree';

const UserModel = types.model('UserModel', {
    id: types.identifier,
    displayName: types.string,
    photoURL: types.string,
    email: types.string,
});

export interface IUserModel extends Instance<typeof UserModel> {}

export default UserModel;
